"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGlobalNavQueryParam2 = exports.useGlobalNavQueryParam = void 0;
var react_1 = require("react");
var router_1 = require("next/router");
var state_1 = require("../state");
var useGlobalNavUrl_hook_1 = require("./useGlobalNavUrl.hook");
var state_2 = require("../../v2/core/state");
/**
 * This hooks should be used to keep the curricula param in the URL
 * Use it in a high level component to update all pages query param.
 * @param curriculaCode
 */
var useGlobalNavQueryParam = function () {
    var _a;
    var router = (0, router_1.useRouter)();
    var appendCurricula = (0, useGlobalNavUrl_hook_1.useGlobalNavUrl)().appendCurricula;
    var globalNav = (0, state_1.useGlobalNav)();
    var globalNavId = (_a = globalNav === null || globalNav === void 0 ? void 0 : globalNav.selected) === null || _a === void 0 ? void 0 : _a.id;
    (0, react_1.useEffect)(function () {
        if (globalNavId)
            appendCurricula(globalNavId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router.pathname, globalNavId]);
};
exports.useGlobalNavQueryParam = useGlobalNavQueryParam;
/**
 * This hooks should be used to keep the curricula param in the URL
 * Use it in a high level component to update all pages query param.
 * @param curriculaCode
 */
var useGlobalNavQueryParam2 = function () {
    var _a;
    var appendCurricula = (0, useGlobalNavUrl_hook_1.useGlobalNavUrl)().appendCurricula;
    var globalNav = (0, state_2.useGlobalNavV2)();
    var hasCurriculum = !!((_a = globalNav === null || globalNav === void 0 ? void 0 : globalNav.selected) === null || _a === void 0 ? void 0 : _a.code);
    var attachCurriculumToUrl = function (item) {
        var isExternalItem = !!(item === null || item === void 0 ? void 0 : item.url);
        if (!(item === null || item === void 0 ? void 0 : item.code) || isExternalItem)
            return;
        appendCurricula(item.code);
    };
    (0, react_1.useEffect)(function () {
        attachCurriculumToUrl(globalNav === null || globalNav === void 0 ? void 0 : globalNav.selected);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasCurriculum]);
    return {
        attachCurriculumToUrl: attachCurriculumToUrl,
    };
};
exports.useGlobalNavQueryParam2 = useGlobalNavQueryParam2;
